import gql from 'graphql-tag'

export const SUBSCRIBE_ORDER_DETAIL_FOR_VEHICLE = gql`
subscription orderDetails($orderId:uuid!){
  orderDetails(where: {orderId: {_eq: $orderId}}) {
    id
    pickupVehicleAssignId
    PIckupTempo{
      id   
      tempo {id name } 
      driverDetail {id name }
     }
    PickupTruck{ 
      id  
      truck {id name } 
      driverDetail {id name }
     }
    transportVehicleAssignId
    truckOrder{
     id
     truck {id name } 
     driverDetail {id name }
    }
  }
}
`
export const SUBSCRIBE_ORDER_DETAIL = gql`
subscription orderDetails($orderId:uuid!){
  orderDetails(where: {orderId: {_eq: $orderId}}) {
    id
    lrObject
    orderId
    orderReadiness
    pickupConfirmation
    pickupPoint
  }
}
`
